import { joinURL } from 'ufo';
import { useMerchantUrlUtils } from '~/composables/useMerchantUrlUtils';

/**
 * Middleware that ensures a 'c' is set as the merchantSlug
 * Example redirects:
 * - https://affiliate.bauhaus.info/login → https://affiliate.bauhaus.info/c/login
 */
export default defineNuxtRouteMiddleware(async (to) => {
	const computedOrigin = joinURL(window.location.origin, to.fullPath);

	const {
		isStaticMerchantUrl,
		hasStaticMerchantSlug,
		getRouteWithStaticSlug,
	} = useMerchantUrlUtils();

	if (isStaticMerchantUrl(computedOrigin) && !hasStaticMerchantSlug(computedOrigin)) {
		return navigateTo(getRouteWithStaticSlug(to));
	}
});
